import {
  Component,
  EventEmitter,
  OnDestroy,
  OnInit,
  Output
} from '@angular/core';
import { Router } from '@angular/router';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs';
import { ToDoService } from '../to-do.service';
import { PriceModifications } from './price-modifications.model';

@Component({
  selector: 'cs-price-modifications',
  standalone: false,
  templateUrl: './price-modifications.component.html',
  styleUrls: ['./price-modifications.component.scss']
})
export class PriceModificationsComponent implements OnInit, OnDestroy {
  public modificationRequests: Array<PriceModifications>;
  private $onDestroy = new Subject();
  public isLoading: boolean = true;
  @Output()
  public closeTodo = new EventEmitter<void>();

  constructor(private service: ToDoService, private router: Router) {}

  public ngOnDestroy(): void {
    this.$onDestroy.next(0);
    this.$onDestroy.complete();
  }

  public ngOnInit(): void {
    this.service
      .getPriceModifications()
      .pipe(takeUntil(this.$onDestroy))
      .subscribe(resp => {
        this.modificationRequests = resp;
        this.isLoading = false;
      });
  }

  public requestClick(request: PriceModifications): void {
    this.router.navigate(
      ['/crm/customers/price-modification-requests/approval'],
      {
        queryParams: { modificationId: request.modificationId }
      }
    );
    this.closeTodo.emit();
  }
}
